import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsWarning } from '@deephaven/icons';
import ThemeExport from "./ThemeExport.js";
import LoadingSpinner from "./LoadingSpinner.js";
import "./LoadingOverlay.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A loading overlay that handles displaying a loading spinner or an error message
 */
function LoadingOverlay(_ref) {
  var _ref$isLoaded = _ref.isLoaded,
    isLoaded = _ref$isLoaded === void 0 ? false : _ref$isLoaded,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? null : _ref$errorMessage,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$scrimClassName = _ref.scrimClassName,
    scrimClassName = _ref$scrimClassName === void 0 ? 'iris-panel-scrim-background' : _ref$scrimClassName,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? ThemeExport.transitionMs : _ref$timeout,
    dataTestId = _ref['data-testid'],
    onErrorAction = _ref.onErrorAction;
  var nodeRef = useRef(null);
  var messageTestId = dataTestId != null ? "".concat(dataTestId, "-message") : undefined;
  var spinnerTestId = dataTestId != null ? "".concat(dataTestId, "-spinner") : undefined;
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: Boolean(errorMessage) || !isLoaded || isLoading,
    timeout: timeout,
    classNames: classNames(className, {
      fade: isLoaded
    }),
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: nodeRef,
    children: /*#__PURE__*/_jsx("div", {
      ref: nodeRef,
      className: "fill-parent-absolute",
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx("div", {
        className: classNames('iris-panel-message-overlay', 'fill-parent-absolute', {
          [scrimClassName]: isLoaded
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: "message-content",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "message-icon",
            children: [isLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
              className: "loading-spinner-large",
              "data-testid": spinnerTestId
            }), !isLoading && errorMessage != null && /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsWarning
            })]
          }), errorMessage != null && /*#__PURE__*/_jsx("div", {
            className: "message-text",
            "data-testid": messageTestId,
            children: errorMessage
          }), onErrorAction != null && errorMessage != null && /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn btn-link error-action-button",
            onClick: onErrorAction,
            children: "Reset"
          })]
        })
      })
    })
  });
}
export default LoadingOverlay;
//# sourceMappingURL=LoadingOverlay.js.map